import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaDataTable from './VaDataTable.vue'

export const VaDataTable = withConfigTransport(_VaDataTable)

export * from './types'
export * from './fabrics'
